import React, { Fragment } from 'react';
import { Button } from 'reactstrap';
import { bool, string, func } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import WithPlaceholder from '../../hoc/WithPlaceholder';

const propTypes = {
  sendFeedback: func.isRequired,
  changeCommentHandler: func.isRequired,
  comment: string.isRequired,
  loading: bool.isRequired,
};

const defaultProps = {
  loading: false,
  comment: '',
};

const FaqFeedbackForm = ({ sendFeedback, changeCommentHandler, comment, loading }) => (
  <>
    <WithPlaceholder
      id="comment"
      type="input"
      name="comment"
      value={comment}
      placeholder="faq.feedback.field.title"
      defaultMessage="Please advise us how to improve the article"
      onChange={changeCommentHandler}
      readOnly={loading}
    />
    <Button
      className="float-right"
      color="primary"
      size="md"
      outline
      onClick={() => sendFeedback(false)}
      disabled={comment.length < 4 || loading}
    >
      {loading ? (
        <FormattedMessage id="faq.feedback.button.sending" defaultMessage="Sending..." />
      ) : (
        <FormattedMessage id="faq.feedback.button.send" defaultMessage="Send Feedback" />
      )}
    </Button>
  </>
);

FaqFeedbackForm.propTypes = propTypes;
FaqFeedbackForm.defaultProps = defaultProps;

export default FaqFeedbackForm;
